// extracted by mini-css-extract-plugin
export var icon = "_5u-1";
export var subtext = "_5u-0";